import _ from 'lodash';
import '../filters/properties';

import {Component, Module} from 'app/decorators';
import ApplicatorStore from 'app/stores/applicator';

import BasePicker from './base.picker';
import tpl from './applicator.picker.html';



@Module({
    name: "app.directives.applicator.picker",
    modules: [
        ApplicatorStore,
        'app.filters.properties',
    ],
})
@Component({
    selector: 'blnd-applicator-picker',
    bindings: {
        ngModel: '=',
        company: '<',  // one-way binding
        fieldname: '@',
        mode: '@',
        type: '@',
    },
    template: tpl,
})
export default class C extends BasePicker {
    constructor ($scope, $element, ApplicatorStore) {
        "ngInject";
        super($element);
        this.fetched = false;
        this.$scope = $scope;
        this.store = ApplicatorStore;
        this.store.init();

        // Creates separate list of objects for each component.
        // Do not use ApplicatorStore.list here! As this is singleton and it is shared
        // between components
        this.list = [];

        if (this.company) {
            this.store.params.company = this.company.id;
        }
    }

    $onInit () {
        let self = this;
        self.currentCompany = {};

        self.watcher = self.$scope.$watch(() => self.company, function (newValue, oldValue) {
            if (newValue === oldValue) { return; }
            self.store.params.company = self.company.id;
            self.enabled = true;
            self.ngModel = null;
            self.fetched = false;
            self.refresh();
        }, true);
    }

    $postLink() {
        this.refresh();
    }

    onSelect ($item, $model) { }

    _push (obj) {
        if (angular.isUndefined(obj) || obj === null) {  return ; }
        let self = this;
        let i = self.list.findIndex(p => p.id === obj.id);
        if (i >= 0) {
            self.list.splice(i, 1);
        }
        self.list.unshift(obj);
    }

    refresh (search, $select) {
        let self = this;
        if (self.fetched) {
            return;
        }

        let refreshPromise = this.store.refresh().then(function(response){
            self.fetched = true;
            if (self.fieldname) {
                let applicatorsHaulers = response.list.plain();
                self.list = applicatorsHaulers.map(o => {
                    return {
                        [self.fieldname]: o,
                        "title": o.title,
                    };
                });
            } else {
                self.list = response.list;
            }

            if (search === '') {
                self._push(self.ngModel);
            }
        });

        return refreshPromise;
    }


    get applicators () {
        if (this.ngModel.length === 0) {
            return '-';
        }
        let applicatorsHaulers = _.groupBy(this.ngModel, `${this.fieldname}.title`);
        return _.map(applicatorsHaulers, (value, key) => key).join(', ');
    }
}



// WEBPACK FOOTER //
// ./src/app/directives/applicator.picker.js